<template>
  <form @submit.prevent="fazerConsulta(chaveacesso)" class="form-home">
    <div class="card" style="border:0px">
      <div class="text-center">
        <img src="/infonotas.ico" alt="imagem">
    <p>
        Bem-vindo ao site do InfoNotas! Aqui você pode utilizar a versão mais recente do nosso poderoso sistema de acompanhamento de NFs em tempo real.
    </p>
      </div>
      <div class="card-body">
        <div class="form-group">
          <input autofocus type="number" v-model="chaveacesso" class="form-control" placeholder="Nova chave de acesso"> <!-- placeholder="Chave de acesso"> -->
        </div>
        <button class="btn btn-primary w-100" :disabled="loading">
          <template v-if="loading">
            Processando...
            <i class="fa fa-spinner fa-spin"></i>
          </template>
          <template v-else>
          #Seguir Danfe
          <i class="fa fa-sign-in-alt"></i>
          </template>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'Home',
  data: {
    imagem: 'img/logo_infonotas.png'
  },
   methods: {
    async fazerConsulta (chaveacesso) {
      let chaveId=chaveacesso

      try {
        const res = await this.$firebase.auth().signInWithEmailAndPassword('novo20@btllog.com.br', 'a12345678')

        this.$router.push({name: 'consulta',params:{Chave:chaveId}})

      } catch (err) {
        console.log(err)
      }
    }
  }
};
</script>

<style lang="scss">
.form-home {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .card {
    width: 20%;
    color: var(--darker);
  }
  /* Hide HTML5 Up and Down arrows. */
input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
}
</style>


